import React from 'react';
import { styled } from '@compiled/react';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import { token } from '@atlaskit/tokens';
import { useDateTimeFormatter } from '@atlassian/jira-issue-format-date/src/main.tsx';
import type { CmdbObjectAttributeDefault } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeDefault;
};

const AttributeWithIcon = ({ formattedValue }: { formattedValue: string }) => (
	<Wrapper>
		<CalendarIcon spacing="spacious" label="" />
		<span>{formattedValue}</span>
	</Wrapper>
);

export const DateAttribute = ({ attribute }: Props): React.JSX.Element | null => {
	const { formatDateOnly } = useDateTimeFormatter();

	const [objectAttributeValue = null] = attribute.objectAttributeValues;
	if (objectAttributeValue === null || !objectAttributeValue.value) {
		return null;
	}

	return <AttributeWithIcon formattedValue={formatDateOnly(objectAttributeValue.value)} />;
};
export const DateTimeAttribute = ({ attribute }: Props): React.JSX.Element | null => {
	const { formatDateTime } = useDateTimeFormatter();

	const [objectAttributeValue = null] = attribute.objectAttributeValues;
	if (objectAttributeValue === null || !objectAttributeValue.value) {
		return null;
	}

	return <AttributeWithIcon formattedValue={formatDateTime(objectAttributeValue.value)} />;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.100'),
});
